module.exports = __webpack_public_path__ + "img/H4.7e1857b6.png";